import { Sucursal } from './sucursal.model';

export class Comercio{

  constructor(public idComercio: number, public nombre: string, public sitioWeb: string, public descripcion: string, public urlLogoImagen: string, public urlLogoImagenBanner: string) {}

  }
